import { LazyImport, LazyModule } from "owa-bundling";

// Import the types but not the implementation
import type * as addinsInitializerTypes from "./addinsInitializer";

const lazyModule: LazyModule<typeof addinsInitializerTypes> = new LazyModule(() => import(/* webpackChunkName: "AddinsInitializer" */ "./addinsInitializer"), { name: "AddinsInitializer" });

export const lazyAddinsInitializer: LazyImport<typeof addinsInitializerTypes.initializeAddins, typeof lazyModule> = new LazyImport(lazyModule, m => m.initializeAddins);
